<script>
import ImageWrapper from '@/components/atoms/ImageWrapper'
import GeneralInfo from '@/components/atoms/restaurant/GeneralInfo'
import isEmpty from 'lodash.isempty'
export default {
    name: 'SearchResult',
    components: { GeneralInfo, ImageWrapper },
    props: {
        result: null,
        restaurant: Boolean,
        meal: Boolean,
        tag: Boolean,
    },
    computed: {
        selectedTags() {
            let tags = this.$route.query.tag_names
            return tags && tags.length >= 0
                ? typeof tags === 'string'
                    ? [tags]
                    : tags.map((tag) => tag)
                : []
        },
        deliveryTime() {
            const time = this.restaurant
                ? this.result?.delivery?.time
                : this.result?.restaurant?.delivery?.time
            return time
                ? time.max === time.min
                    ? `${time.max}`
                    : `${time.min}-${time.max}`
                : undefined
        },
        hasAddress() {
            return !isEmpty(this.$store.getters['order/address'])
        },
        restaurantSlug() {
            const restaurant = this.restaurant ? this.result : this.result?.restaurant
            return restaurant ? `${restaurant.slug}` : undefined
        },
        deliveryPrice() {
            return this.result?.delivery?.price
        },
        rating() {
            return this.result?.rating ? Math.round(this.result.rating) / 2 : 0
        },
    },
    methods: {
        setTag() {
            if (!(this.selectedTags.includes(this.result.slug) && this.selectedTags.length === 1)) {
                this.setQuery({ tag_names: [this.result.slug] }, 'restaurant-list', {
                    pageLoader: false,
                })
            }
            this.$emit('click')
        },
        onClick() {
            this.$restaurant.fetchRestaurant(this.restaurantSlug)
            this.$emit('click')
        },
    },
}
</script>

<template lang="pug">
.search-result.text-wrap(v-if="result")
    .btn.btn-list-item.d-flex.align-items-center.text-sm(v-if="tag" @click="setTag" role="button")
        icon.mr-4.text-99(icon="fa-solid fa-search")
        | {{result.name}} ({{result.restaurant_count}})
    router-link.btn.btn-list-item.d-flex(
        v-if="restaurant || meal" 
        @click.native="onClick"
        :to="{name: 'restaurant', params: { slug: restaurantSlug }, query: { meal: meal ? result.id : undefined }}")
        image-wrapper.mr-4.border-radius-md.overflow-hidden(:src="result.image" width="64px" height="64px" fill)
        .d-flex.flex-column(:class="{'justify-content-between': hasAddress}")
            span.text-m.font-weight-semibold {{result.name}}
            span.text-sm(v-if="meal") {{result.restaurant.name}}
            span.text-sm
                template(v-if="hasAddress && deliveryTime")
                    | {{deliveryTime}}{{$t('restaurant.minute')}}
                    | •
                | {{rating}}
                icon.ml-2.text-73(icon="fa-solid fa-star" size="sm")
            general-info(v-if="restaurant && hasAddress" :model="result" sm)

</template>
